import { useRef, useState } from "react";

/**
 * Gives a render-function a STABLE component identity across re-renders.
 * Defining `const Field = (props) => <input …/>` inside a component creates a new component type on every
 * render, so React unmounts/remounts the input on each keystroke (focus loss, keyboard flicker on mobile).
 * `const Field = useRenderer((props) => …)` keeps the same type while always calling the latest closure.
 */
export function useRenderer(render) {
  const ref = useRef(render);
  ref.current = render;
  const [Component] = useState(() => {
    const Stable = (props) => ref.current(props);
    Stable.displayName = "StableRenderer";
    return Stable;
  });
  return Component;
}
